// LoadingModal.jsx
import React from "react";
import { Modal, Backdrop, Fade, Box, Typography } from "@mui/material";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const antIcon = <LoadingOutlined style={{ fontSize: 48, color: "#555" }} spin />;

export default function LoadingModal({ message }) {
  // Always open while loading
  const open = true;

  return (
    <Modal
      open={open}
      closeAfterTransition
      disableEscapeKeyDown
      onClose={() => {}}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: { bgcolor: "rgba(0,0,0,0.5)" }
      }}
    >
      <Fade in={open} timeout={{ enter: 500, exit: 200 }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            outline: "none"
          }}
        >
          <Spin indicator={antIcon} />
          <Typography sx={{ mt: 2 }}>{message}</Typography>
        </Box>
      </Fade>
    </Modal>
  );
}
